(() => {
  const shuffle = (items) => {
    const result = [...items];
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  };

  const initialize = (root) => {
    if (root.dataset.mixInitialized) return;
    root.dataset.mixInitialized = 'true';
    const grid = root.querySelector('.product-grid');
    const button = root.querySelector('[data-apparel-remix]');
    const status = root.querySelector('[data-apparel-status]');
    if (!grid || !button) return;
    const limit = Number(root.dataset.limit) || 9;
    const pageCount = Number(root.dataset.pages) || 1;
    const pageParam = root.dataset.pageParam || 'page';
    const candidates = new Map();
    const visitedPages = new Set([Number(root.dataset.page) || 1]);
    const storageKey = 'thornvella-featured-apparel-v2';
    let previous = [];
    let busy = false;
    try { previous = JSON.parse(sessionStorage.getItem(storageKey) || '[]'); } catch (_) {}
    if (!Array.isArray(previous)) previous = [];

    const collect = (source) => {
      source.querySelectorAll('template[data-apparel-candidate]').forEach((template) => {
        const handle = template.dataset.handle;
        const type = template.dataset.type;
        if (!handle || !type || !template.content.querySelector('.product-card')) return;
        const title = (template.dataset.design || handle).trim().toLowerCase();
        const parts = title.replace(/ [–—] /g, ' - ').split(' - ');
        candidates.set(handle, {
          handle,
          type,
          theme: parts[0],
          design: parts.slice(0, 2).join(' - ').replace(/\s*\([^)]*\)\s*$/, ''),
          template
        });
      });
    };
    collect(root);

    const fetchPage = async (page) => {
      const url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('sections', root.dataset.sectionId);
      url.searchParams.set(pageParam, String(page));
      const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(10000) });
      if (!response.ok) throw new Error('Apparel mix unavailable');
      const payload = await response.json();
      const html = payload[root.dataset.sectionId];
      if (!html) throw new Error('Apparel mix unavailable');
      collect(new DOMParser().parseFromString(html, 'text/html'));
      visitedPages.add(page);
    };

    const loadMore = async () => {
      const pages = shuffle(Array.from({ length: pageCount }, (_, index) => index + 1)
        .filter((page) => !visitedPages.has(page))).slice(0, 3);
      await Promise.allSettled(pages.map(fetchPage));
    };

    const render = (announce) => {
      const pool = shuffle([...candidates.values()]);
      const selected = [];
      const designs = new Set();
      const typeCounts = new Map();
      const themeCounts = new Map();
      const priorHandles = new Set(previous);
      const types = shuffle([...new Set(pool.map((item) => item.type))])
        .sort((a, b) => pool.filter((item) => item.type === a).length - pool.filter((item) => item.type === b).length);
      const target = Math.max(limit, types.length);
      const pick = (type) => {
        const options = pool.filter((item) => !type || item.type === type);
        if (!options.length) return;
        const score = (item) => [
          designs.has(item.design) ? 1 : 0,
          themeCounts.get(item.theme) || 0,
          priorHandles.has(item.handle) ? 1 : 0,
          typeCounts.get(item.type) || 0
        ];
        let best = options[0];
        let bestScore = score(best);
        options.slice(1).forEach((item) => {
          const itemScore = score(item);
          for (let index = 0; index < itemScore.length; index++) {
            if (itemScore[index] === bestScore[index]) continue;
            if (itemScore[index] < bestScore[index]) {
              best = item;
              bestScore = itemScore;
            }
            break;
          }
        });
        pool.splice(pool.indexOf(best), 1);
        selected.push(best);
        designs.add(best.design);
        typeCounts.set(best.type, (typeCounts.get(best.type) || 0) + 1);
        themeCounts.set(best.theme, (themeCounts.get(best.theme) || 0) + 1);
      };
      types.forEach(pick);
      while (selected.length < target && pool.length) pick();
      if (!selected.length) return;
      const fragment = document.createDocumentFragment();
      shuffle(selected).forEach((item) => fragment.append(item.template.content.cloneNode(true)));
      grid.querySelectorAll(':scope > .product-card').forEach((card) => card.remove());
      grid.append(fragment);
      previous = selected.map((item) => item.handle);
      try { sessionStorage.setItem(storageKey, JSON.stringify(previous)); } catch (_) {}
      document.dispatchEvent(new CustomEvent('thornvella:products-updated'));
      if (announce && status) status.textContent = status.dataset.message;
    };

    const refresh = async (announce) => {
      if (busy) return;
      busy = true;
      if (announce && status) status.textContent = '';
      button.disabled = true;
      grid.setAttribute('aria-busy', 'true');
      try {
        await loadMore();
        render(announce);
      } finally {
        busy = false;
        button.disabled = false;
        button.hidden = candidates.size <= limit && pageCount <= 1;
        grid.removeAttribute('aria-busy');
      }
    };

    button.hidden = false;
    button.addEventListener('click', () => refresh(true));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          refresh(false);
        }
      }, { rootMargin: '600px' });
      observer.observe(root);
    } else {
      refresh(false);
    }
  };
  document.querySelectorAll('[data-apparel-mix]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-apparel-mix]').forEach(initialize);
  });
})();

